/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { TokenizationService } from '@/services/tokenization-service';
const is = require('is_js');

const SERVICE_NAME = 'SupplyStepperService';

const getTransSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.TokenizationService') as TokenizationService;
};

export class SupplyStepperPageService {
  private static instance: SupplyStepperPageService;
  private vapp: VApplication;
  private cropData: any;
  private complianceData: any;
  private orgSelected: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.cropData = this.cropData;
    this.complianceData = this.complianceData;
    this.orgSelected = this.orgSelected;
  }

  public static getInstance(props: any = {}): SupplyStepperPageService {
    if (!SupplyStepperPageService.instance) {
      SupplyStepperPageService.instance = new SupplyStepperPageService(props);
    }
    return SupplyStepperPageService.instance;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  private setCropData(data: any) {
    this.cropData = data;
  }

  private setComplianceData(data: any) {
    this.complianceData = data;
  }

  private setOrg(data: any) {
    this.orgSelected = data;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();

    compProps = await agent.getGetSupplyStepper({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //org list

    compProps = await agent.getSupplierOrgProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public setSupplyCropForm(args: any) {
    this.setCropData(args);
  }

  public getCropFormData() {
    return this.cropData;
  }

  public setComplianceForm(args: any) {
    this.setComplianceData(args);
  }

  public getComplianceData() {
    return this.complianceData;
  }

  public setOrgSelected(args: any) {
    this.setOrg(args);
  }

  public getOrgSelected(args: any) {
    return this.orgSelected;
  }

  public getPreview() {
    const agent = getAgent();
    let _args = {
      formData: this.cropData,
      compData: this.complianceData,
      orgList: this.orgSelected,
    };
    return agent.getFormatPreviewDetailSync(_args);
  }

  public formatOrgList(args: any) {
    const agent = getAgent();
    return agent.getFormatOrgListSync(args);
  }

  public formatComplForm(args: any) {
    const agent = getAgent();
    return agent.getFormatComplFormSync(args);
  }

  public submitTransaction(args: any) {
    const storageSrv = StorageModule?.getInstance();
    const orgDetails = storageSrv?.get('myProfile', 'local')?.orgData;

    let _args = {
      batchDetail: this.cropData,
      complianceProof: args?.map((item: any) => {
        return {
          ...item,
          doc: this.complianceData[`${item?.id}-evidence`][0]?.base64,
          validFrom: this.complianceData[`${item?.id}-validFrom`],
          validUntil: this.complianceData[`${item?.id}-validUntil`],
        };
      }),
      recipients:
        Array.isArray(this.orgSelected) &&
        args?.map((item: any) => {
          return {
            id: item?.appCardId,
          };
        }),
      whoIsMyOrg: orgDetails?.id,
    };
    console.log(`transaction args`, _args);
    return getTransSrv()?.createTxn(_args);
  }
}
